/**
 * OrderLineVariantService
 * Service for OrderLineVariant entity operations
 * Route: api/orderlinevariants
 * Controller: OrderLineVariantsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderLineVariantService
 * Handles order line variant CRUD operations.
 * Backend now returns OrderLineVariantModelView (enriched) instead of raw entities.
 * Maps to /api/orderlinevariants endpoint
 */
export class OrderLineVariantService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderLineVariantService.DEFAULT_SERVICE_PATH,
            basePath: OrderLineVariantService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== QUERY BY LINE ====================
    /**
     * Get order line variants by line ID
     * GET /api/orderlinevariants?lineId={lineId}
     */
    async getByLineId(lineId) {
        const response = await this.getByLineIdRaw(lineId);
        return response.data ?? [];
    }
    /**
     * Get order line variants by line ID (raw)
     */
    getByLineIdRaw(lineId) {
        const url = this.buildUrl(`?lineId=${lineId}`);
        return this.http.get(url);
    }
}
OrderLineVariantService.DEFAULT_SERVICE_PATH = 'orders';
OrderLineVariantService.BASE_PATH = 'api/orderlinevariants';
//# sourceMappingURL=OrderLineVariantService.js.map